var starmax_nn = {
    name: "starmax nn",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [71,0,6,155,2,193,1,153,2,55,6,142,35,42,17,156,2,134,164,144,35,102,8,154,2,0,0,53,86,255,219,237,170,136,65],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [71,0,6,154,2,195,1,151,2,54,6,150,35,39,17,159,2,144,161,140,35,94,8,162,2,0,0,53,86,255,254,213,86,136,65],
        },
        {
            function: "KEY_MODE",
            name: "KEY_MODE",
            icon: "KEY_MODE",
            command: [71,0,6,159,2,192,1,149,2,55,6,144,35,39,17,158,2,134,164,139,35,95,8,160,2,0,0,53,86,255,253,106,174,136,65],
        },
        {
            function: "KEY_TIMER",
            name: "KEY_TIMER",
            icon: "KEY_TIMER",
            command: [71,0,6,149,2,187,1,161,2,61,6,150,35,38,17,141,2,125,164,149,35,101,8,152,2,0,0,53,86,255,182,221,182,136,65],
        },
        {
            function: "KEY_ZOOM",
            name: "KEY_ZOOM",
            icon: "KEY_ZOOM",
            command: [71,0,6,152,2,193,1,154,2,57,6,146,35,44,17,153,2,134,164,148,35,98,8,158,2,0,0,53,86,255,223,109,86,136,65],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [71,0,6,154,2,192,1,149,2,60,6,152,35,48,17,137,2,128,164,150,35,105,8,151,2,0,0,53,86,255,190,186,174,136,65],
        },
        {
            function: "KEY_EPG",
            name: "KEY_EPG",
            icon: "KEY_EPG",
            command: [71,0,6,154,2,196,1,147,2,59,6,184,35,33,17,146,2,109,164,172,35,102,8,156,2,0,0,53,86,255,171,254,170,136,65],
        },
        {
            function: "KEY_TV_RADIO",
            name: "KEY_TV_RADIO",
            icon: "KEY_TV_RADIO",
            command: [71,0,6,149,2,194,1,156,2,58,6,142,35,59,17,137,2,138,164,143,35,88,8,167,2,0,0,53,86,255,221,182,182,136,65],
        },
        {
            function: "KEY_ASPECT",
            name: "KEY_ASPECT",
            icon: "KEY_ASPECT",
            command: [71,0,6,154,2,196,1,149,2,57,6,145,35,38,17,149,2,123,164,148,35,102,8,155,2,0,0,53,86,255,247,213,170,136,65],
        },
        {
            function: "KEY_TXT",
            name: "KEY_TXT",
            icon: "KEY_TXT",
            command: [71,0,6,155,2,191,1,149,2,62,6,143,35,43,17,141,2,132,161,145,35,92,8,165,2,0,0,53,86,255,239,107,86,136,65],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [71,0,6,155,2,192,1,151,2,56,6,146,35,33,17,152,2,130,164,139,35,92,8,165,2,0,0,53,86,255,223,218,170,136,65],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [71,0,6,157,2,193,1,148,2,55,6,143,35,39,17,153,2,130,164,147,35,98,8,159,2,0,0,53,86,255,175,250,170,136,65],
        },
        {
            function: "KEY_FAV",
            name: "KEY_FAV",
            icon: "KEY_FAV",
            command: [71,0,6,155,2,194,1,149,2,56,6,140,35,41,17,156,2,122,164,146,35,102,8,153,2,0,0,53,86,255,235,235,170,136,65],
        },
        {
            // function: "KEY_USB",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [71,0,6,152,2,193,1,147,2,63,6,150,35,38,17,138,2,126,164,150,35,103,8,153,2,0,0,53,86,255,181,125,234,136,65],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [71,0,6,159,2,194,1,149,2,53,6,140,35,16,17,153,2,127,164,140,35,100,8,155,2,0,0,53,86,255,255,170,170,136,65],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [71,0,6,156,2,195,1,151,2,56,6,168,35,30,17,154,2,120,164,147,35,105,8,151,2,0,0,53,86,255,191,234,170,136,65],
        },
        {
            function: "KEY_FIND",
            name: "KEY_FIND",
            icon: "KEY_FIND",
            command: [71,0,6,156,2,190,1,151,2,60,6,146,35,36,17,139,2,131,164,148,35,92,8,164,2,0,0,53,86,255,187,245,170,136,65],
        },
        {
            function: "KEY_SAT",
            name: "KEY_SAT",
            icon: "KEY_SAT",
            command: [71,0,6,153,2,196,1,150,2,55,6,144,35,44,17,139,2,131,164,144,35,92,8,162,2,0,0,53,86,255,175,189,86,136,65],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [71,0,6,150,2,197,1,150,2,57,6,144,35,43,17,160,2,135,164,141,35,98,8,156,2,0,0,53,86,255,218,246,234,136,65],
        },
        {
            function: "KEY_NET",
            name: "KEY_NET",
            icon: "KEY_NET",
            command: [71,0,6,153,2,194,1,151,2,57,6,136,35,42,17,150,2,143,161,145,35,104,8,152,2,0,0,53,86,255,235,181,214,136,65],
        },
        {
            // function: "KEY_RETURN",
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [71,0,6,155,2,194,1,152,2,56,6,142,35,36,17,151,2,139,164,141,35,102,8,156,2,0,0,53,86,255,234,245,234,136,65],
        },
        {
            function: "KEY_EXIT",
            name: "KEY_EXIT",
            icon: "KEY_EXIT",
            command: [71,0,6,156,2,192,1,149,2,59,6,143,35,34,17,139,2,137,161,143,35,91,8,168,2,0,0,53,86,255,213,123,234,136,65],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [71,0,6,154,2,193,1,151,2,60,6,147,35,4,17,139,2,129,164,143,35,79,8,177,2,0,0,53,86,255,213,219,214,136,65],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [71,0,6,149,2,195,1,151,2,60,6,149,35,32,17,153,2,124,164,138,35,96,8,159,2,0,0,53,86,255,174,222,182,136,65],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [71,0,6,155,2,192,1,150,2,59,6,147,35,43,17,138,2,132,164,142,35,96,8,161,2,0,0,53,86,255,170,239,214,136,65],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [71,0,6,149,2,193,1,158,2,59,6,145,35,36,17,144,2,113,164,165,35,102,8,154,2,0,0,53,86,255,237,181,182,136,65],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [71,0,6,155,2,194,1,149,2,58,6,140,35,36,17,153,2,139,164,138,35,75,8,180,2,0,0,53,86,255,170,191,234,136,65],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [71,0,6,150,2,196,1,152,2,59,6,150,35,46,17,137,2,129,164,142,35,96,8,158,2,0,0,53,86,255,181,221,214,136,65],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [71,0,6,153,2,190,1,152,2,61,6,146,35,32,17,139,2,129,164,149,35,107,8,148,2,0,0,53,86,255,181,251,170,136,65],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [71,0,6,155,2,194,1,146,2,60,6,149,35,31,17,143,2,139,164,138,35,104,8,152,2,0,0,53,86,255,213,247,170,136,65],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [71,0,6,157,2,193,1,146,2,57,6,170,35,39,17,152,2,133,161,148,35,92,8,164,2,0,0,53,86,255,170,255,170,136,65],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [71,0,6,156,2,191,1,145,2,63,6,144,35,30,17,139,2,129,164,136,35,102,8,155,2,0,0,53,86,255,189,245,106,136,65],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [71,0,6,149,2,194,1,150,2,59,6,147,35,43,17,151,2,132,164,142,35,100,8,156,2,0,0,53,86,255,221,237,106,136,65],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [71,0,6,153,2,195,1,148,2,62,6,145,35,33,17,154,2,132,164,145,35,90,8,167,2,0,0,53,86,255,174,253,106,136,65],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [71,0,6,152,2,192,1,154,2,60,6,143,35,47,17,152,2,131,164,152,35,104,8,150,2,0,0,53,86,255,237,235,106,136,65],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [71,0,6,151,2,193,1,153,2,59,6,148,35,34,17,153,2,135,164,147,35,90,8,167,2,0,0,53,86,255,182,251,106,136,65],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [71,0,6,156,2,193,1,150,2,60,6,148,35,18,17,139,2,139,164,140,35,94,8,163,2,0,0,53,86,255,214,247,106,136,65],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [71,0,6,152,2,195,1,149,2,61,6,152,35,45,17,154,2,142,164,147,35,93,8,166,2,0,0,53,86,255,171,127,106,136,65],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [71,0,6,155,2,196,1,152,2,53,6,151,35,38,17,140,2,138,164,136,35,96,8,160,2,0,0,53,86,255,245,234,234,136,65],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [71,0,6,155,2,191,1,150,2,58,6,151,35,35,17,155,2,130,164,137,35,89,8,167,2,0,0,53,86,255,186,250,234,136,65],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [71,0,6,153,2,196,1,149,2,58,6,150,35,44,17,140,2,133,164,145,35,101,8,154,2,0,0,53,86,255,251,213,106,136,65],
        },
        {
            function: "KEY_HD",
            name: "KEY_HD",
            icon: "KEY_HD",
            command: [71,0,6,154,2,196,1,148,2,58,6,145,35,38,17,140,2,140,164,139,35,101,8,154,2,0,0,53,86,255,173,126,234,136,65],
        },
        {
            function: "KEY_F1",
            name: "KEY_F1",
            icon: "KEY_F1",
            command: [71,0,6,154,2,196,1,149,2,55,6,140,35,35,17,151,2,130,161,146,35,118,8,137,2,0,0,53,86,255,251,106,182,136,65],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [71,0,6,151,2,197,1,150,2,60,6,142,35,36,17,140,2,130,164,150,35,105,8,152,2,0,0,53,86,255,173,222,214,136,65],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [71,0,6,154,2,194,1,153,2,57,6,143,35,33,17,138,2,140,164,142,35,92,8,162,2,0,0,53,86,255,219,182,214,136,65],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [71,0,6,155,2,192,1,152,2,57,6,145,35,33,17,152,2,125,164,143,35,92,8,165,2,0,0,53,86,255,215,183,86,136,65],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [71,0,6,156,2,191,1,151,2,57,6,148,35,40,17,154,2,138,164,141,35,105,8,152,2,0,0,53,86,255,215,238,170,136,65],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [71,0,6,155,2,191,1,153,2,58,6,148,35,42,17,151,2,144,164,145,35,102,8,155,2,0,0,53,86,255,183,187,86,136,65],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [71,0,6,153,2,195,1,152,2,57,6,140,35,42,17,138,2,134,164,143,35,101,8,156,2,0,0,53,86,255,247,106,214,136,65],
        },
        {
            function: "KEY_PREVIOUS",
            name: "KEY_PREVIOUS",
            icon: "KEY_PREVIOUS",
            command: [71,0,6,154,2,193,1,152,2,56,6,164,35,45,17,150,2,132,164,148,35,104,8,153,2,0,0,53,86,255,239,214,170,136,65],
        },
        {
            function: "KEY_NEXT",
            name: "KEY_NEXT",
            icon: "KEY_NEXT",
            command: [71,0,6,155,2,190,1,155,2,58,6,167,35,44,17,146,2,152,164,138,35,101,8,156,2,0,0,53,86,255,183,246,170,136,65],
        },
        {
            function: "KEY_DISPLAY",
            name: "KEY_DISPLAY",
            icon: "KEY_DISPLAY",
            command: [71,0,6,159,2,194,1,151,2,55,6,146,35,30,17,144,2,138,164,152,35,89,8,166,2,0,0,53,86,255,213,109,246,136,65],
        },
        {
            function: "KEY_FUNC",
            name: "KEY_FUNC",
            icon: "KEY_FUNC",
            command: [71,0,6,152,2,194,1,153,2,60,6,146,35,41,17,140,2,127,164,143,35,104,8,153,2,0,0,53,86,255,171,223,86,136,65],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [71,0,6,152,2,195,1,152,2,58,6,169,35,31,17,140,2,139,164,144,35,91,8,165,2,0,0,53,86,255,189,186,182,136,65],
        },
        {
            function: "KEY_HELP",
            name: "KEY_HELP",
            icon: "KEY_HELP",
            command: [71,0,6,150,2,193,1,153,2,61,6,146,35,46,17,152,2,139,161,149,35,100,8,156,2,0,0,53,86,255,187,186,214,136,65],
        },
    ]
}
export default starmax_nn